import React from 'react';
import { Provider } from 'jotai';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { appStore } from './store/jotaiStore';
import Main from './components/main';
import ProjectHandover from './components/ProjectHandover';
import ProjectHandoverForm from './components/ProjectHandoverForm';
import Estimating from './components/Estimating';
import SOPPortal from './components/sop/SOPPortal';
import FlagsDashboard from './components/anomaly/FlagsDashboard';
import FlagDetail from './components/anomaly/FlagDetail';
import AnomalyReports from './components/anomaly/AnomalyReports';
import AnomalyChat from './components/anomaly/AnomalyChat';

const msalInstance = new PublicClientApplication(msalConfig);

export default function App() {
  return (
    <Provider store={appStore}>
      <Router>
        <Routes>
          {/* Public routes - no authentication required */}
          <Route path="/projecthandoverform" element={<ProjectHandover />} />
          <Route path="/projecthandover" element={<ProjectHandoverForm />} />
          <Route path="/estimating" element={<Estimating />} />
          <Route path="/sop" element={<SOPPortal />} />
          <Route path="/anomaly/flags" element={<FlagsDashboard />} />
          <Route path="/anomaly/flags/:id" element={<FlagDetail />} />
          <Route path="/anomaly/reports" element={<AnomalyReports />} />
          <Route path="/anomaly/chat" element={<AnomalyChat />} />
          
          {/* Protected routes - authentication required */}
          <Route path="/" element={
            <MsalProvider instance={msalInstance}>
              <Main />
            </MsalProvider>
          } />
          <Route path="/daily-report" element={
            <MsalProvider instance={msalInstance}>
              <Main initialTab="Daily Field Report" standalone />
            </MsalProvider>
          } />
          {/* Quick Report — simplified two-step daily report */}
          <Route path="/daily-report2" element={
            <MsalProvider instance={msalInstance}>
              <Main initialTab="Daily Field Report 2" standalone />
            </MsalProvider>
          } />
          {/* Billing TV board for the VoltaGrid field office monitor */}
          <Route path="/billing-tv" element={
            <MsalProvider instance={msalInstance}>
              <Main initialTab="Billing TV" standalone />
            </MsalProvider>
          } />
          {/* Old deep link — keep it working */}
          <Route path="/field-report" element={<Navigate to="/daily-report" replace />} />
          <Route path="/Forecasting" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </Provider>
  );
}
